/**
 * The host's "end this round" strip during a segment; a game can't end the show itself.
 * Hidden for a one-segment show.
 */

import type { JsonObject, Snapshot } from '@gsf/contract';

export interface ShowBarProps {
  readonly snapshot: Snapshot;
  readonly send: (type: string, payload?: JsonObject) => void;
  readonly connected: boolean;
}

export function ShowBar({ snapshot, send, connected }: ShowBarProps) {
  const { core } = snapshot;
  const total = core.show.segments.length;
  if (total < 2 || !core.segment) return null;

  const position = core.show.segments.findIndex((s) => s.index === core.segment?.index);
  const title = core.show.segments[position]?.title ?? core.segment.title;

  return (
    <div className="show-bar">
      <span className="show-bar-where">
        <strong>{title}</strong>
        <span className="faint">
          {' '}
          — round {position + 1} of {total}
        </span>
      </span>
      <button
        className="btn"
        disabled={!connected}
        onClick={() => send('core:advanceSegment')}
        // A Jeopardy board has no terminal phase; this is the only way its segment closes.
        title="Close this round, convert its scores, and show the standings"
      >
        End this round
      </button>
    </div>
  );
}
